import React from 'react';
import { PortfolioTableItemDetails } from '../PortfolioTableItem';
import { formatDate } from '../../../utils/dateUtils';
import { SectionBlock } from './SectionBlock';

type DetailsSectionProps = { portfolio: PortfolioTableItemDetails };

export const DetailsSection: React.FC<DetailsSectionProps> = ({ portfolio }) => {
  const detailItems = [
    { label: 'Created by', value: portfolio.createdBy ?? '' },
    { label: 'Activation date', value: formatDate(portfolio.activatedAt), testId: 'portfolio-detail-activation-date' },
    { label: 'Closure date', value: formatDate(portfolio.closedAt), testId: 'portfolio-detail-closure-date' },
    { label: 'Rubric', value: portfolio.rubrik },
    { label: 'Details', value: portfolio.details, testId: 'portfolio-detail-details' },
    { label: 'Special beneficial owner (100% quota)', value: portfolio.allocatedBoName, info: 'TBD' },
  ];

  return <SectionBlock list={detailItems} />;
};
